import React, { useEffect, useRef } from 'react';
import './WinModal.css';

export default function WinModal({ level, moves, score, onNextLevel, onRestart }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const particles = Array.from({ length: 120 }, () => ({
      x: canvas.width / 2, y: canvas.height / 2,
      vx: (Math.random() - 0.5) * 12,
      vy: (Math.random() - 0.5) * 12 - 4,
      radius: Math.random() * 5 + 2,
      color: `hsl(${Math.random() * 360}, 100%, 65%)`,
      life: 1, decay: Math.random() * 0.015 + 0.008,
      gravity: 0.22,
    }));

    let animId;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.vx; p.y += p.vy; p.vy += p.gravity;
        p.life -= p.decay; p.vx *= 0.99;
        if (p.life <= 0) return;
        ctx.save();
        ctx.globalAlpha = p.life;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        const grad = ctx.createRadialGradient(p.x - p.radius * 0.3, p.y - p.radius * 0.3, 0, p.x, p.y, p.radius);
        grad.addColorStop(0, '#fff');
        grad.addColorStop(1, p.color);
        ctx.fillStyle = grad;
        ctx.shadowBlur = 10; ctx.shadowColor = p.color;
        ctx.fill(); ctx.restore();
      });
      if (particles.some(p => p.life > 0)) animId = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(animId);
  }, []);

  return (
    <div className="win-overlay">
      <canvas ref={canvasRef} className="particle-canvas" />
      <div className="win-modal glass-card">
        <div className="win-trophy">🏆</div>
        <h2 className="win-title">Level Complete!</h2>
        <p className="win-sub">Amazing! You solved Level {level}!</p>
        <div className="win-stats">
          <div className="win-stat">
            <span className="ws-icon">🎯</span>
            <span className="ws-val">{moves}</span>
            <span className="ws-label">Moves</span>
          </div>
          <div className="win-stat highlight">
            <span className="ws-icon">⭐</span>
            <span className="ws-val">{score.toLocaleString()}</span>
            <span className="ws-label">Score</span>
          </div>
          <div className="win-stat">
            <span className="ws-icon">🏅</span>
            <span className="ws-val">Lv {level}</span>
            <span className="ws-label">Level</span>
          </div>
        </div>
        <div className="win-stars">
          {[1, 2, 3].map(i => (
            <span key={i} className="win-star" style={{ animationDelay: `${i * 0.2}s` }}>⭐</span>
          ))}
        </div>
        <div className="win-btns">
          <button className="win-btn restart" onClick={onRestart}>🔄 Restart</button>
          <button className="win-btn next" onClick={onNextLevel}>Next Level ▶</button>
        </div>
      </div>
    </div>
  );
}
